export const packingSlipStatusLists = ["draft", "definitive", "completed"];
